import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux';
import { Map } from 'immutable'
import * as cssTheme from 'theme'
import moment from 'moment-timezone'

import Row from './Row'
import { Dropdown } from 'components'

import * as actionCreators from 'store/actions'
import { getTimezones } from 'utils'

const Container = styled.div`
    display: grid;
`

class PreferencesTab extends Component {
    constructor(props){
        super(props);
        this.tzOptions = getTimezones()
    }

    toggleHandler = (type) => {
        const oldUser = Map({...this.props.user})
        let updatedUser = this.props.user
        if(type === 'THEME'){
            updatedUser['theme'] = this.props.user['theme'] === 'Dark' ? 'Light' : 'Dark'
            this.themeHandler(updatedUser['theme'])
        } else {
            updatedUser[type.toLowerCase()] = !this.props.user[type.toLowerCase()]
        }
        console.log(updatedUser)
        this.props.updateUser(updatedUser, oldUser)
    }

    themeHandler = (nextTheme) => {
        let theme = nextTheme === 'Light' ? cssTheme.light 
                    : nextTheme === 'Dark' ? cssTheme.dark
                    : null;
        for (const [key, value] of Object.entries(theme)) {
            document.documentElement.style.setProperty(key,value);
        }
    
        for (const [key, value] of Object.entries(cssTheme.base)) {
            document.documentElement.style.setProperty(key,value);
        }
    }

    tzHandler = (tz) => {
        const oldUser = Map({...this.props.user})
        let updatedUser = this.props.user
        updatedUser['timezone'] = tz
        this.props.updateUser(updatedUser, oldUser)
    }

    render() {
        const timezoneSelector = <Dropdown value={this.tzOptions[this.props.user['timezone']]} 
                                    options={this.tzOptions}
                                    style={{width: '15rem', fontSize: '0.8rem'}}
                                    onSelect={this.tzHandler}/>
        return (
            <Container>
                <Row title='Dark mode' subtitle='Overall color theme for the application.'
                    value={this.props.user['theme'] === 'Dark'} borderRadius='5px 5px 0 0'
                    styles={this.props.styles}
                    onSelect={() => this.toggleHandler('THEME')}/>
                <Row title='Full width' subtitle='Fully utilise all available screen width. Applicable mainly for the list view'
                    value={this.props.user['full_width']}
                    styles={{...this.props.styles, borderWidth: '0 2px 2px 2px'}}
                    onSelect={() => this.toggleHandler('FULL_WIDTH')}/>
                <Row title='Item divider' subtitle='Show a divider after each item. Applicable mainly for the list view'
                    value={this.props.user['item_divider']} 
                    styles={{...this.props.styles, borderWidth: '0 2px 2px 2px'}}
                    onSelect={() => this.toggleHandler('ITEM_DIVIDER')}/>
                {/* <Row title='Show all completed' subtitle='For each item, show any completed items if any.'
                    value={this.props.user['show_completed']} 
                    styles={{...this.props.styles, borderWidth: '0 2px 2px 2px'}}
                    onSelect={() => this.toggleHandler('SHOW_COMPLETED')}/> */}
                

                <Row title='Timezone' borderRadius='0 0 5px 5px' selector={timezoneSelector} 
                    styles={{...this.props.styles, borderWidth: '0 2px 2px 2px'}}/>
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateUser: (user, oldUser) => dispatch(actionCreators.updateUser(user, oldUser)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PreferencesTab);
